<template>
    <Dialog v-model="value" transition="dialog-top-transition" title="Histórico de ajustes do e-mail" width="800" :unlimit-height="true">
        <v-simple-table>
            <thead>
                <tr>
                    <td>Status</td>
                    <td>Data e Hora do ajuste</td>
                    <td>E-mail antigo</td>
                    <td>E-mail novo</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="log_email in historico" :key="log_email.id">
                    <td>{{ log_email.sucesso ? "Sucesso" : "Erro" }}</td>
                    <td>{{ log_email.data_hora }}</td>
                    <td>{{ log_email.email_antigo }}</td>
                    <td>{{ log_email.email_novo }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div v-if="!show_result" class="d-flex justify-center width-100 mt-6">
            Carregando...
        </div>
        <div v-else-if="show_message" class="d-flex justify-center width-100 mt-6">
            {{ mensagem }}
        </div>
        <div v-else-if="historico.length === 0 && show_result" class="d-flex justify-center width-100 mt-6">
            {{ mensagem }}
        </div>
        <div class="d-flex justify-center mt-6">
            <v-btn color="primary" @click="close">OK</v-btn>
        </div>
    </Dialog>
</template>

<script>

  export default {
    name: 'DialogChangeEmailHistory',
    props: {
      value: Boolean,
      idPedido: {
        type: [String, Number],
        required: false
      }
    },
    data: () => ({
      historico: [],
      show_result: false,
      show_message: false,
      mensagem: ''
    }),
    watch: {
      async value (newValue) {
        if (newValue) {
          this.historico = []
          this.show_result = false
          this.show_message = false
          await this.getHistory(this.idPedido)
        }
      }
    },
    methods: {
      getHistory (id_pedido) {
        this.$http.get(`/proposta/email_change_history/${id_pedido}`).then(response => {
          this.historico = response.data.change_email_logs
          if (this.historico.length === 0) {
            this.mensagem = 'Nenhum resultado encontrado.'
          }
        }).catch(error => {
          console.error(error)
          this.mensagem = 'Erro ao carregar o histórico, tente novamente em instantes'
          this.show_message = true
        }).finally(() => {
          this.show_result = true
        })
      },
      close () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
.width-100 {
  width: 100%;
}
</style>
